import React, { useRef } from 'react';
import { Row, Button } from 'reactstrap';
import moment from 'moment/moment';
import { useReactToPrint } from 'react-to-print';
import { CSVLink } from 'react-csv';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileCsv } from '@fortawesome/free-solid-svg-icons';

//Components
import MainCard from '../../../components/MainCard/MainCard';
import CardRelatorio from '../components/CardRelatorio';

//Helpers
import mascaras from '../../../helpers/mascaras';

//Context
import { useAuth } from 'context/auth';

export default function RelatorioColetasPorTransportador({ dadosRelatorio, btnVoltar, filtros }) {
    const { session, setupVariavel } = useAuth();
    //Referencia do relatorio para download do csv
    const exportRef = useRef(null);
    //Botão de exportação csv
    const BtnExportCsv = () => {
        return (
            <Button className='mb-3' color='success' onClick={() => exportRef.current.link.click()}>
                <FontAwesomeIcon icon={faFileCsv} /> Gerar CSV
            </Button>
        )
    }
    //Referencia do relatorio para exportar pdf
    const refRelatorio = useRef();
   
    //Cabeçalhos para a listagem das coletas por meio do cardRelatorio
    const headersColetas = [
        { value: `Nº ${setupVariavel?.siglaDocumentoColeta}`, objectValue: "item_Coleta", col: "3" },
        { value: "RAMO DE ATIVIDADE", objectValue: "segmento", col: "5" },
        { value: "REGIONAL", objectValue: "regional", col: "4" },

        { value: "MODALIDADE DE COLETA", objectValue: "tipo_Coleta", col: "12" },
        { value: "RESÍDUOS", objectValue: "residuo", col: "12" },

        { value: "COLETADO", objectValue: "volume", col: "6" },
        { value: "STATUS", objectValue: "status_Coleta", col: "6" },
        { value: "DATA/HORA DA COLETA", formatDate: true, objectValue: "data_Coleta", col: "6" },
        { value: "DATA/HORA DO RECEBIMENTO", formatDate: true, objectValue: "data_Descarte", col: "6" },
        { value: "PLACA/IMPLEMENTO", objectValue: "placaImplemento", separator: "/", col: "12" },

        { value: "CNPJ", objectValue: "cpfcnpj", col: "12" },
        { value: "NOME DO GERADOR", objectValue: "nome_Gerado", col: "12" },
        { value: "ENDEREÇO", objectValue: "local_Coleta", col: "12" },
    ];
    //headers da exportação do csv
    const headersExport = [
        { key: "bairro", label: "BAIRRO" },
        { key: "cep", label: "CEP" },
        { key: "cidade", label: "CIDADE" },
        { key: "cnpJ_Transportador", label: "CNPJ DO TRANSPORTADOR" },
        { key: "contato", label: "CONTATO" },
        { key: "contato_Destino", label: "CONTATO DO DESTINO" },
        { key: "contato_Transportador", label: "CONTATO DO TRANSPORTADOR" },
        { key: "contrato", label: "CONTRATO" },
        { key: "cpfcnpj", label: "CPF/CNPJ" },
        { key: "data_Coleta", label: "DATA DA COLETA" },
        { key: "data_Descarte", label: "DATA DO DESCARTE" },
        { key: "data_Roteiro", label: "DATA DO ROTEIRO" },
        { key: "destino", label: "DESTINO" },
        { key: "email", label: "E-MAIL" },
        { key: "endereco_Destino", label: "ENDEREÇO DO DESTINO" },
        { key: "endereco_Transportador", label: "ENDERECO DO TRANSPORTADOR" },
        { key: "fone", label: "FONE" },
        { key: "fone_Destino", label: "FONE DO DESTINO" },
        { key: "item_Coleta", label: `Nº ${setupVariavel?.siglaDocumentoColeta}`},
        { key: "local_Coleta", label: "LOCAL DA COLETA" },
        { key: "logradouro", label: "LOGRADOURO" },
        { key: "motivo_Nao_Coleta", label: "MOTIVO DA NÃO COLETA" },
        { key: "nome_Destino", label: "NOME DO DESTINO" },
        { key: "nome_Gerado", label: "NOME DO GERADOR" },
        { key: "nome_Transportador", label: "NOME DO TRANSPORTADOR" },
        { key: "numero", label: "NUMERO" },
        { key: "pesoDestinado", label: "PESO DESTINADO" },
        { key: "pesoEntrada", label: "PESO DE ENTRADA" },
        { key: "placaImplemento", label: "PLACA/IMPLEMENTO" },
        { key: "recipiente", label: "RECIPIENT" },
        { key: "regional", label: "REGIONAL" },
        { key: "residuo", label: "RESIDUO" },
        { key: "responsavel", label: "RESPONSAVEL" },
        { key: "responsavel_Destino", label: "RESPONSAVEL DO DESTINO" },
        { key: "segmento", label: "SEGMENTO" },
        { key: "setor_Coleta", label: "SETOR DA COLETA" },
        { key: "status_Coleta", label: "STATUS DA COLETA" },
        { key: "taG_Recipiente", label: "TAG" },
        { key: "tipo_Coleta", label: "TIPO DA COLETA" },
        { key: "tipo_Destino", label: "TIPO DO DESTINO" },
        { key: "tipo_Veiculo", label: "TIPO DO VEICULO" },
        { key: "uf", label: "UF" },
        { key: "unidade", label: "UNIDADE DE MEDIDA" },
        { key: "veiculo", label: "VEICULO" },
        { key: "volume", label: "VOLUME" },
        { key: "volumetria", label: "VOLUMETRIA" }
    ]
    //Cabeçalhos para a listagem dos manivefestos de residuos por meio do cardRelatorio
    const headersManifestoDeResiduos = [

        { value: "IMPLEMENTO", objectValue: "implemento", col: "4" },
        { value: "QUANTIDADE DE IMPLEMENTOS", objectValue: "total_Implemento", col: "4" },
        { value: "PORCENTAGEM", objectValue: "porcentagem_Implemento", col: "4" },
    ];
    //Cabeçalhos para a listagem dos totalizadores de residuos solidos por meio do cardRelatorio
    const headersTotalizadoresResiduosSolidos = [
        { value: "MODALIDADE DE COLETA", objectValue: "modalidade", col: "6" },
        { value: "TIPO DE RESÍDUOS", objectValue: "tipoResiduo", col: "6" },

        { value: "INFORMADO", objectValue: "qtde_Informada_Contrado", col: "6" },
        { value: "GERADO", objectValue: "totalGerado", col: "6" },
    ];
    //Cabeçalhos para a listagem dos totalizadores de ramo de atividade por meio do cardRelatorio
    const headersTotalizadoresRamoAtividade = [
        { value: "RAMO DE ATIVIDADE", objectValue: "ramoAtividade", col: "6" },
        { value: "N° DE GERADORES", objectValue: "numeroGeradore", col: "6" },
    ];
    //Cabeçalhos para a listagem dos totalizadores por numero de mtr por meio do cardRelatorio
    const headersTotalizadoresPorNMTR = [
        { value: "RANKING GERAL", objectValue: "ranking", col: "6" },
        { value: "TRANSPORTADOR", objectValue: "nome_TR", col: "6" },
        { value: `N° DE ${setupVariavel?.siglaDocumentoColeta}`, objectValue: "total_MTR_TR", col: "6" },
        { value: "PERCENTUAL", objectValue: "percentual", col: "6" },
    ];
    //Cabeçalhos para a listagem dos totalizadores por status e modalidade usando o cardRelatorio
    const headersTotalizadoresPorStatusEModalidade = [
        { title: true, objectValue: "titulo", col: "6" },
        { title: true, objectValue: "quantidade", col: "6" },
    ];
    //Cabeçalhos para a listagem dos totalizadores por quantidade de transportadores por meio do cardRelatorio
    const headersTotalizadoresQuantidadeTransportadores = [
        { value: "RANKING GERAL", objectValue: "ranking", col: "6" },
        { value: "TRANSPORTADOR", objectValue: "nome_TR", col: "6" },
        { value: `N° DE ${setupVariavel?.siglaDocumentoColeta}`, objectValue: "quantidade", col: "6" },
        { value: "PERCENTUAL", objectValue: "percentual", col: "6" },
    ];

    //Função assionada assim que o botão de imprimir pdf é clicado
    const handlePrint = useReactToPrint({
        content: () => refRelatorio.current,
        copyStyles: true,
        documentTitle: "Relatório detalhado por transportador",
    });

    return (
        <MainCard btnVoltarInTop={btnVoltar} btnImprimir={handlePrint} BtnAction1InTop={BtnExportCsv}>

            <CSVLink separator={";"} data={dadosRelatorio.listaColetas} headers={headersExport} filename="Relatorio de coletas por transportador.csv" target="_blank" ref={exportRef}></CSVLink>
            <div className="mt-4 relatorio w-100" ref={refRelatorio}>
                <div className="print m-2 d-flex align-items-center justify-content-between">
                    <p>Emitido por: {session.nome}</p>
                    <p>Data de emissão: {moment().format("DD/MM/YYYY HH:mm")}</p>
                </div>
                {setupVariavel?.logoTipo &&
                    <div className="d-flex align-items-center justify-content-center">
                        <img src={"data:image/png;base64," + setupVariavel?.logoTipo} style={{ maxWidth: '70%'}}  />
                    </div>
                }
                <div className="header">
                    <h4 className='text-black'>Relatório detalhado por transportador</h4>
                    <Row>
                        <div className='col-4'>
                            <p><span className="fw-bold">Período:</span> {moment(filtros.dataInicial).format("DD/MM/YYYY")} à {moment(filtros.dataFinal).format("DD/MM/YYYY")}</p>
                        </div>
                        <div className='col-4'>
                            <p><span className="fw-bold">Status Coletas:</span> {filtros.status}</p>
                        </div>
                    </Row>
                    <Row>
                        <div className='col-4'>
                            {filtros.transportadorId_selected
                                ?
                                <p><span className="fw-bold">Transportador:</span> {filtros.transportadorId_selected.label}</p>
                                :
                                <p><span className="fw-bold">Transportador:</span> Todos</p>
                            }
                        </div>
                        <div className='col-4'>
                            {filtros.modalidadeId_selected
                                ?
                                <p><span className="fw-bold">Modalidade:</span> {filtros.modalidadeId_selected.label}</p>
                                :
                                <p><span className="fw-bold">Modalidade:</span> Todas</p>
                            }
                        </div>
                    </Row>
                </div>
                <div className="body">
                    <h5 className='rounded-3 bg-secondary text-light p-2'>DADOS DO TRANSPORTADOR</h5>
                    <Row className='content-rel'>
                        <div className="col-6"><span className="fw-bold">Nome:</span> {dadosRelatorio.transportador.fantasia}</div>
                        <div className="col-6"><span className="fw-bold">CNPJ:</span> {mascaras.cnpjMask(dadosRelatorio.transportador.cnpj)}</div>
                        <div className="col-4"><span className="fw-bold">Responsável:</span> {dadosRelatorio.transportador.responsavel}</div>
                        <div className="col-4"><span className="fw-bold">E-mail:</span> {dadosRelatorio.transportador.email}</div>
                        <div className="col-4"><span className="fw-bold">Telefone:</span> {mascaras.celularMask(dadosRelatorio.transportador.fone)}</div>
                        <div className="col-4"><span className="fw-bold">CEP:</span> {mascaras.cepMask(dadosRelatorio.transportador.cep)}</div>
                        <div className="col-4"><span className="fw-bold">Cidade:</span> {dadosRelatorio.transportador.cidade}</div>
                        <div className="col-4"><span className="fw-bold">UF:</span> {dadosRelatorio.transportador.uf}</div>
                        <div className="col-4"><span className="fw-bold">Bairro:</span> {dadosRelatorio.transportador.bairro}</div>
                        <div className="col-4"><span className="fw-bold">Rua:</span> {dadosRelatorio.transportador.logradouro}</div>
                        <div className="col-4"><span className="fw-bold">Numero:</span> {dadosRelatorio.transportador.numero}</div>
                    </Row>
                    <h5 className='mt-4 rounded-3 bg-secondary text-light p-2'>Coletas</h5>
                    <CardRelatorio headers={headersColetas} items={dadosRelatorio.listaColetas} />
                    <div className="contentGroup">
                        <h5 className='mt-4 rounded-3 bg-secondary text-light p-2'>MANIFESTOS DE TRANSPORTE DE RESÍDUOS</h5>
                        <p className='p-1 border-bottom'><span className="fw-bold">TOTAL DE {setupVariavel?.siglaDocumentoColeta}s LANÇADAS: </span>{dadosRelatorio.dadosManifestos[0]?.total_MTR}</p>
                        <h5 className='p-1 border-bottom fw-bold'>IMPLEMENTO RODOVIÁRIO</h5>
                        <CardRelatorio headers={headersManifestoDeResiduos} items={dadosRelatorio.dadosManifestos} />
                        <h5 className='p-1 border-bottom fw-bold'>STATUS</h5>
                        <div className=" row ">

                            <div className="p-1 col-4 border-bottom">
                                <p className=' '><span className="fw-bold">COLETADO: </span></p>

                            </div>
                            <div className="p-1 col-4 border-bottom">
                                {dadosRelatorio.dadosManifestos[0]?.total_Coletado}
                            </div>
                            <div className="p-1 col-4 border-bottom">
                                {dadosRelatorio.dadosManifestos[0]?.porcentagem_Coletado}
                            </div>
                            <div className="p-1 col-4 border-bottom">
                                <p><span className="fw-bold">RECEBIDO: </span></p>

                            </div>
                            <div className="p-1 col-4 border-bottom">
                                {dadosRelatorio.dadosManifestos[0]?.total_Baixado}
                            </div>
                            <div className="p-1 col-4 border-bottom">
                                {dadosRelatorio.dadosManifestos[0]?.porcentagem_Baixado}
                            </div>
                        </div>

                    </div>
                    <div className="contentGroup">
                        <h5 className='mt-4 rounded-3 bg-secondary text-light p-2'>RESÍDUOS SÓLIDOS</h5>
                        <CardRelatorio headers={headersTotalizadoresResiduosSolidos} items={dadosRelatorio.totalizadoresResiduosSolidos} />
                        <p className='p-1 border-bottom'><span className="fw-bold">TOTAL: </span>{dadosRelatorio.totalizadoresResiduosSolidos[0]?.totalGerado}</p>
                    </div>
                    <div className="contentGroup">
                        <h5 className='mt-4 rounded-3 bg-secondary text-light p-2'>TOTALIZADORES DE {setupVariavel?.siglaDocumentoColeta}S POR STATUS E MODALIDADE</h5>
                        <CardRelatorio headers={headersTotalizadoresPorStatusEModalidade} items={dadosRelatorio.totalizadoresStatusModalidade} />

                    </div>
                    <div className="contentGroup">
                        <h5 className='mt-4 rounded-3 bg-secondary text-light p-2'>TOTALIZADORES POR RAMO DE ATIVIDADE</h5>
                        <CardRelatorio headers={headersTotalizadoresRamoAtividade} items={dadosRelatorio.totalizadoresRamoAtividade} />
                        <p className='p-1 border-bottom'><span className="fw-bold">TOTAL: </span>{dadosRelatorio.totalizadoresRamoAtividade[0].total}</p>
                    </div>
                    <div className="contentGroup">
                        <h5 className='mt-4 rounded-3 bg-secondary text-light p-2'>TOTALIZADOR POR N° DE {setupVariavel?.siglaDocumentoColeta}</h5>
                        <CardRelatorio headers={headersTotalizadoresPorNMTR} items={dadosRelatorio.totalizadoresRankingNumeroMTR} />
                        <p className='p-1 border-bottom'><span className="fw-bold">TOTAL: </span>{dadosRelatorio.totalizadoresRankingNumeroMTR[0]?.total_Geral}</p>
                    </div>
                    <div className="contentGroup">
                        <h5 className='mt-4 rounded-3 bg-secondary text-light p-2'>TOTALIZADOR POR QUANTIDADE TRANSPORTADA</h5>
                        <CardRelatorio headers={headersTotalizadoresQuantidadeTransportadores} items={dadosRelatorio.totalizadoresRankingQuantidadeTransportadores} />
                        <p className='p-1 border-bottom'><span className="fw-bold">TOTAL: </span>{dadosRelatorio.totalizadoresRankingQuantidadeTransportadores[0] ? dadosRelatorio.totalizadoresRankingQuantidadeTransportadores[0]?.total_Geral : "0"} Kg</p>
                    </div>
                </div>
            </div>
        </MainCard>
    )
}